import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import './styles.css';
import DomainLogo from '../domain-components/domain_logo';

import { useTranslation } from 'react-i18next';

const Header = ({ location: { pathname } }) => {
  const { t } = useTranslation();

  return (
    <div className='container-header'>
      <div className='container-header__wrapper'>
        <div className='container-header__left'>
          <DomainLogo className='container-header__left--logo' />
        </div>
        <div>
          <Link
            className='container-header__button'
            to={['/email-confirmation', '/register', '/reset-password'].includes(pathname) ? '/login' : '/register'}
          >
            {['/email-confirmation', '/register', '/reset-password'].includes(pathname) ? t('header.button.login') : t('header.button.register')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Header);